/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'eye-cross': {
    width: 25,
    height: 20,
    viewBox: '0 0 25 20',
    data: '<path pid="0" d="M17.905 3.412L21.323.264a1 1 0 011.354 1.472L19.675 4.5C23.001 6.848 25 10 25 10s-3.677 8-12.5 8c-2.334 0-4.311-.569-5.957-1.403l-2.866 2.639a1 1 0 01-1.354-1.472l2.441-2.249C1.484 13.167 0 10 0 10s5.148-8 12.5-8c1.988 0 3.807.573 5.405 1.412zm-1.118 3.75l-2.229 2.052c.096.244.148.509.148.786 0 1.205-.987 2.182-2.206 2.182-.336 0-.654-.075-.94-.207l-2.228 2.053A5.18 5.18 0 0012.5 15.09c2.868 0 5.146-2.254 5.146-5.09 0-1.056-.315-2.03-.86-2.839zm-1.425-1.407A5.195 5.195 0 0012.5 4.91c-2.868 0-5.146 2.254-5.146 5.09 0 .92.24 1.78.662 2.52l2.313-2.13a2.173 2.173 0 01-.035-.39c0-1.205.987-2.182 2.206-2.182.19 0 .373.024.548.068l2.314-2.131z" _fill="#213F6B" fill-rule="evenodd"/>'
  }
})
